<template>
  <Activity
    :title="t(`app.main.button.deliveries.${context.toLowerCase()}`)"
    :back="{ name: 'DeliveryListActivity' }">
    <offline-indicator v-if="!delivery && !online" />

    <font-awesome-icon icon="spinner" size="3x" spin v-else-if="loading"/>

    <div v-else>
      <delivery-details :delivery="delivery" :context="context" />
    </div>

  </Activity>
</template>

<script>
import Activity from "@/app/components/Activity.vue";

import {computed, watch} from '@vue/composition-api'
import OfflineIndicator from "@/app/components/OfflineIndicator.vue";
import DeliveryDetails from "@/app/components/delivery/DeliveryDetails.vue";

export default {
  components: {OfflineIndicator, Activity, DeliveryDetails},

  setup() {
    const { t } = window.useI18n()
    const store = window.useStore()
    const router = window.useRouter()

    const { id, context } = router.currentRoute.params

    const online = computed(() => store.state.pwa.online)
    const fetchInfo = computed(() => store.state.pwa.deliveryNotes[id])
    const loading = computed(() => online.value && (typeof fetchInfo.value === 'undefined' || fetchInfo.value.loading))

    const delivery = computed(() => {
      if (loading.value) {
        return null
      }
      if (!fetchInfo.value) {
        return null
      }
      const delivery = fetchInfo.value.data
      if (!Object.keys(delivery).length) {
        return null
      }
      return delivery
    })

    watch(fetchInfo, (info) => {
      if (typeof info == 'undefined' && online.value) {
        store.dispatch('APP_FETCH_DELIVERY_NOTE', id)
      }
    }, { deep: true, immediate: true })

    watch(online, () => {
      if (online.value) {
        store.dispatch('APP_FETCH_DELIVERY_NOTE', id)
      }
    })

    return {
      t,
      context,
      id,
      store,
      online,
      loading,
      delivery,
    }
  }
}
</script>
